/**
 * Client-side blog search filtering when `?q=` is present.
 */
function getBlogSearchQuery() {
  const query = new URLSearchParams(window.location.search).get('q');
  return query ? query.trim().toLowerCase() : '';
}

function filterBlogPosts(root) {
  const query = getBlogSearchQuery();
  const grid = root.querySelector('.blog-posts-container');
  if (!grid || !query) return;

  const items = grid.querySelectorAll('.blog-post-item');
  let visibleCount = 0;

  items.forEach((item) => {
    const searchText = item.dataset.searchText || item.textContent || '';
    const matches = searchText.toLowerCase().includes(query);
    item.hidden = !matches;
    if (matches) visibleCount += 1;
  });

  let emptyMessage = grid.querySelector('.blog-posts__empty-search--js');

  if (visibleCount === 0) {
    if (!emptyMessage) {
      emptyMessage = document.createElement('p');
      emptyMessage.className = 'blog-posts__empty-search blog-posts__empty-search--js';
      grid.appendChild(emptyMessage);
    }

    const displayQuery = new URLSearchParams(window.location.search).get('q') || query;
    emptyMessage.textContent = `No articles found for "${displayQuery}".`;
    emptyMessage.hidden = false;
  } else if (emptyMessage) {
    emptyMessage.hidden = true;
  }
}

function initBlogSearchFilter() {
  const query = getBlogSearchQuery();
  if (!query) return;

  document.querySelectorAll('.blog-posts').forEach((section) => {
    filterBlogPosts(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBlogSearchFilter);
} else {
  initBlogSearchFilter();
}
